import { TipoDeTelefone } from './../../common/types/Telefone'
export const tiposDeTelefone = [
	'Celular',
	'Comercial',
	'Residencial',
	'Outro',
] as TipoDeTelefone[]
